import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function LoadingIcon({ color, className }) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={52}
            height={52}
            viewBox="0 0 52 52"
        >
            <circle fill={color} stroke="none" cx="6" cy="25" r="6">
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.1"
                />
            </circle>
            <circle fill={color} stroke="none" cx="26" cy="25" r="6">
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.2"
                />
            </circle>
            <circle fill={color} stroke="none" cx="46" cy="25" r="6">
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.3"
                />
            </circle>
        </svg>
    );
}

LoadingIcon.propTypes = propTypes;
LoadingIcon.defaultProps = defaultProps;

export default LoadingIcon;
